import { limitedReleasesListConstants } from "../_redux-constants";
import { limitedReleasesListService } from "../../_services";

function getLimitedReleasesList(queryParams) {
  function getLimitedReleasesListLoad() {
    return { type: limitedReleasesListConstants.LIMITED_RELEASES_LIST_LOADING };
  }
  function getLimitedReleasesListSuccess(data) {
    return {
      type: limitedReleasesListConstants.LIMITED_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function getLimitedReleasesListFailure(error) {
    return {
      type: limitedReleasesListConstants.LIMITED_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getLimitedReleasesListLoad());
    return limitedReleasesListService.getLimitedReleasesList(queryParams).then(
      (data) => {
        dispatch(getLimitedReleasesListSuccess(data));
      },
      (error) => {
        dispatch(getLimitedReleasesListFailure(error?.toString()));
      }
    );
  };
}

export const limitedReleasesListActions = {
  getLimitedReleasesList,
};
